/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-vars */
/* eslint-disable no-continue */
import Vue from 'vue';
import contentApi from '../api/contentApi';
import * as types from './types';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as templatesTypes from '@/modules/templates/store/types';
import * as storageTypes from '@/modules/storage/store/types';
import * as rootTypes from '@/store/types';

import helper from '@/core/helper';

function buildCreativeList(creativesResponse, creativeTemplates) {
  const {
    campaignId,
    feedId,
    orderId,
  } = creativesResponse;
  return creativesResponse.creatives
    .map((item) => {
      const associatedTemplate = creativeTemplates.find((template) => template.id === item.creativeTemplateId);
      const sizeName = associatedTemplate ? `${associatedTemplate.width}x${associatedTemplate.height}` : '';
      return ({
        campaignId,
        feedId,
        orderId,
        sizeName,
        ...item,
      });
    });
}

function buildActiveCreativeList(creatives) {
  return creatives.filter((creative) => !creative.paused);
}

async function handleCreatives(creativesResponse, context, selectedCreativeId, isShareeRequest) {
  if (creativesResponse.creatives.length < 1) {
    context.commit(types.CLEAR_CREATIVES);
    return;
  }

  const campaignIds = creativesResponse.campaignId ? creativesResponse.campaignId
    : [...new Set(creativesResponse.creatives.map((creative) => creative.campaignId))];

  const creativeTemplates = await context.dispatch(types.FETCH_CREATIVE_TEMPLATES_BY_CAMPAIGNIDS, campaignIds);

  const creativeList = buildCreativeList(creativesResponse, creativeTemplates);
  const activeCreatives = buildActiveCreativeList(creativeList);
  context.commit(types.SET_CREATIVES, creativeList);
  context.commit(types.SET_ACTIVE_CREATIVES, activeCreatives);

  const previouslySelectedCreative = activeCreatives.find((creative) => creative.id === selectedCreativeId);
  if (previouslySelectedCreative) {
    context.commit(types.SET_CREATIVE, previouslySelectedCreative);
  } else {
    context.commit(types.SET_CREATIVE, activeCreatives[0]);
  }

  if (isShareeRequest) return creativesResponse;
  context.commit(types.SET_CREATIVE_TYPE_SELECTED, creativesResponse?.templateType || 'TEMPLATE_GROUP');
  if (creativesResponse.templateType) {
    const templateSizes = [...new Set(creativesResponse.creatives
      .filter((creative) => !creative.paused)
      .map((creative) => creative.templateSize))];
    context.commit(types.SET_ADD_UNITS_SELECTED, templateSizes);
  }
  context.dispatch(types.FETCH_IMAGE_ASSET_NAMES);
  context.dispatch(types.NEW_FETCH_DISPLAY_PROPERTIES);
  return creativesResponse;
}

function buildFilters(context) {
  const contentItemParams = context.state.contentItemsQueryParams;

  return {
    search: contentItemParams.search,
    stateFilter: {
      states: contentItemParams.states ? [contentItemParams.states] : null,
    },
    matchingHealths: contentItemParams.matchingHealth ? [contentItemParams.matchingHealth] : null,
    languageId: contentItemParams.languageId,
  };
}

const actions = {
  [types.FETCH_FEED]: (context, payload) => contentApi
    .getFeed(payload.advertiserId, payload.feedId)
    .then((response) => response),
  [types.EXPORT_ARTICLES_AS_CSV]: (context, payload) => contentApi.exportArticlesAsCSV(payload)
    .then((response) => response),
  [types.FETCH_ARTICLES]: async (context, payload) => {
    const fetchContentScrapes = payload?.hasOwnProperty('fetchContentScrapes') ? payload.fetchContentScrapes : true;
    const fetchDisplayProperties = payload?.hasOwnProperty('fetchDisplayProperties') ? payload.fetchDisplayProperties : true;
    const fetchLanguages = payload?.hasOwnProperty('fetchLanguages') ? payload.fetchLanguages : true;
    context.commit(types.SET_LOADING_ARTICLES, true);
    if (context.state.languages.length === 0 && fetchLanguages) {
      context.dispatch(types.FETCH_LANGUAGES);
    }
    if (fetchContentScrapes) await context.dispatch(types.NEW_FETCH_CONTENT_SCRAPES, payload);
    await context.dispatch(types.NEW_FETCH_CONTENT_ITEMS, payload);
    if (fetchDisplayProperties) context.dispatch(types.NEW_FETCH_DISPLAY_PROPERTIES);
    context.commit(types.SET_LOADING_ARTICLES, false);
  },
  [types.FETCH_SHOWCASE_ARTICLES]: async (context, payload) => {
    context.commit(types.SET_LOADING_ARTICLES, true);
    await context.dispatch(types.FETCH_SHOWCASE_CONTENT_ITEMS, payload);
    if (context.rootGetters[`campaigns/${campaignTypes.GET_HAS_CAMPAIGN_ACCESS}`]) await context.dispatch(types.NEW_FETCH_DISPLAY_PROPERTIES);
    context.commit(types.SET_LOADING_ARTICLES, false);
  },
  [types.NEW_FETCH_CONTENT_SCRAPES]: (context, payload) => {
    const {
      contentItemsUrlsChanged, newScrapedContent, inProgressContentScrapes, emailOnCompletion,
    } = context.state;
    if (!contentItemsUrlsChanged && newScrapedContent.length > 0) return newScrapedContent;
    const advertisersId = context.rootState.campaigns.selectedAdvertiser.id ?? payload.advertiserId;
    const feedId = context.state.feedId ?? payload.feedId;
    const timeout = 2000;
    let conditionTimeout = null;
    let prevScrapingInProgressLength = 0;
    let iterationNumber = 0;
    const checkContentScrapedFully = (resolve, reject) => {
      contentApi.getScrapedContent({ advertisersId, feedId })
        .then((scrapedContentItems) => {
          if (!scrapedContentItems.scrapes.length) {
            return resolve([]);
          }
          context.dispatch(types.SET_EMAIL_USER_ON_SCRAPE_COMPLETION, scrapedContentItems.scrapes[0].emailOnCompletion);
          const scrapingInProgress = scrapedContentItems.scrapes[0].items
            .filter((contentItem) => contentItem.status.startsWith('IN_PROGRESS') || contentItem.status.startsWith('INITIALISED'));
          const hasFinishedScraping = scrapingInProgress.length === 0 || (scrapingInProgress.length === 1 && scrapingInProgress[0].status.startsWith('INITIALISED'));
          if (hasFinishedScraping) {
            if (inProgressContentScrapes.totalStartLength !== 0) {
              context.commit(types.SET_IN_PROGRESS_CONTENT_SCRAPES, {
                totalStartLength: 0,
                contentItems: [],
              });
              context.dispatch(types.NEW_FETCH_CONTENT_ITEMS, payload);
              context.dispatch(types.NEW_FETCH_DISPLAY_PROPERTIES);
            }
          } else {
            context.commit(types.SET_LOADING_ARTICLES_SECTION, false);
            context.commit(types.SET_LOADING_ARTICLES, false);
            if (inProgressContentScrapes.totalStartLength === 0) {
              context.commit(types.SET_IN_PROGRESS_CONTENT_SCRAPES, {
                totalStartLength: scrapingInProgress.length,
                contentItems: scrapingInProgress,
              });
            }
            if ((inProgressContentScrapes.totalStartLength !== scrapingInProgress.length
              && prevScrapingInProgressLength !== scrapingInProgress.length)
              || iterationNumber === 0
            ) {
              context.commit(types.SET_IN_PROGRESS_CONTENT_SCRAPES, {
                contentItems: scrapingInProgress,
              });
              prevScrapingInProgressLength = scrapingInProgress.length;
              context.dispatch(types.NEW_FETCH_CONTENT_ITEMS, {
                offset: !(context.state.contentItemsQueryParams.hasOwnProperty('search')
              || context.state.contentItemsQueryParams.hasOwnProperty('states')
              || context.state.contentItemsQueryParams.hasOwnProperty('languageId')
              || context.state.contentItemsQueryParams.hasOwnProperty('matchingHealth')
                ),
              });
              context.dispatch(types.NEW_FETCH_DISPLAY_PROPERTIES);
              iterationNumber++;
            }
            conditionTimeout = setTimeout(checkContentScrapedFully, timeout, resolve, reject);
          }
          if (context.state.killCurrentScrapingFetch) {
            context.commit(types.SET_IN_PROGRESS_CONTENT_SCRAPES, {
              totalStartLength: 0,
              contentItems: [],
            });
            context.commit(types.SET_LOADING_ARTICLES_SECTION, false);
            context.commit(types.SET_LOADING_ARTICLES, false);
            context.commit(types.SET_KILL_CURRENT_SCRAPING_FETCH, false);
            clearTimeout(conditionTimeout);
            return resolve([]);
          }
          context.commit(types.SET_CONTENT_SCRAPE_ID, scrapedContentItems.scrapes[0].id);
          context.commit(types.NEW_SET_SCRAPED_CONTENT, scrapedContentItems.scrapes[0].items);
          context.commit(types.SET_SCRAPED_CONTENT, scrapedContentItems.scrapes[0].items);
          context.dispatch(types.SET_CONTENT_ITEMS_URLS_CHANGED, false);
          resolve(scrapedContentItems);
        })
        .catch((errors) => {
          reject(errors);
        });
    };
    return new Promise(checkContentScrapedFully);
  },
  [types.NEW_FETCH_CONTENT_SCRAPES_ONCE]: (context, payload) => {
    const {
      contentItemsUrlsChanged, newScrapedContent,
    } = context.state;
    if (!contentItemsUrlsChanged && newScrapedContent.length > 0) return newScrapedContent;
    const advertisersId = context.rootState.campaigns.selectedAdvertiser.id ?? payload.advertiserId;
    const feedId = context.state.feedId ?? payload.feedId;
    return contentApi.getScrapedContent({ advertisersId, feedId })
      .then((scrapedContentItems) => {
        context.commit(types.SET_CONTENT_SCRAPE_ID, scrapedContentItems.scrapes[0].id);
        context.commit(types.NEW_SET_SCRAPED_CONTENT, scrapedContentItems.scrapes[0].items);
        context.commit(types.SET_SCRAPED_CONTENT, scrapedContentItems.scrapes[0].items);
        return Promise.resolve(scrapedContentItems.scrapes[0].items);
      })
      .catch(() => Promise.reject());
  },
  [types.NEW_FETCH_CONTENT_ITEMS]: (context, payload) => {
    let page = 1;
    let pageSize = 300;
    const hasOffset = payload?.hasOwnProperty('offset');
    if (!context.state.contentItemsQueryParams.hasOwnProperty('page')) {
      if (payload?.hasOwnProperty('page')) {
        context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, payload.page);
        page = payload.page;
      } else {
        context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, { page: 1 });
        page = 1;
      }
    } else page = context.state.contentItemsQueryParams.page;
    if (!context.state.contentItemsQueryParams.hasOwnProperty('pageSize')) {
      if (payload?.hasOwnProperty('pageSize')) {
        context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, { pageSize: payload.pageSize });
        pageSize = payload.pageSize;
      } else {
        context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, { pageSize: 300 });
        pageSize = 300;
      }
    } else pageSize = context.state.contentItemsQueryParams.pageSize;
    function getQuery() {
      let query = '';
      for (const param in context.state.contentItemsQueryParams) {
        if (!context.state.contentItemsQueryParams.hasOwnProperty(param)
            || (param === 'states' && context.state.contentItemsQueryParams[param] === 'FAILED')) continue;
        query += `&${param}=${context.state.contentItemsQueryParams[param]}`;
      }
      return query;
    }

    const contentItemsPayload = {
      feedId: context.state.feedId,
      filtersQuery: getQuery(),
    };

    if (hasOffset && payload.offset) {
      const offset = (context.getters.GET_IN_PROGRESS_CONTENT_ITEMS.length
        + context.getters.GET_FAILED_SCRAPED_CONTENT_ITEMS.length) * -1;
      if ((page * pageSize) + offset > 0) contentItemsPayload.offset = offset;
      else {
        context.commit(types.NEW_SET_CONTENT_ITEMS, []);
        return Promise.resolve([]);
      }
    }

    return contentApi.newGetFeedContent(contentItemsPayload)
      .then((contentItems) => {
        context.commit(types.NEW_SET_CONTENT_ITEMS, contentItems.contentItems);
        context.commit(types.SET_CONTENT_TOTAL_ITEMS, contentItems.totalItems);
        context.commit(types.SET_CONTENT_TOTAL_PUBLISHED_ITEMS, contentItems.totalPublished);
        context.commit(types.SET_IS_SELF_SERVICE_CONTENT, contentItems.isSelfService);
        return Promise.resolve(contentItems);
      })
      .catch((errors) => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: `${errors}`,
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      });
  },
  [types.FETCH_SHOWCASE_CONTENT_ITEMS]: (context, payload) => {
    const defaultPage = 1;
    const defaultPageSize = 300;
    let page = defaultPage;
    let pageSize = defaultPageSize;
    if (!context.state.contentItemsQueryParams.hasOwnProperty('page')) {
      if (payload?.hasOwnProperty('page')) {
        context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, payload.page);
        page = payload.page;
      } else {
        context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, { page: defaultPage });
        page = defaultPage;
      }
    } else page = context.state.contentItemsQueryParams.page;
    if (!context.state.contentItemsQueryParams.hasOwnProperty('pageSize')) {
      if (payload?.hasOwnProperty('pageSize')) {
        context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, { pageSize: payload.pageSize });
        pageSize = payload.pageSize;
      } else {
        context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, { pageSize: defaultPageSize });
        pageSize = defaultPageSize;
      }
    } else pageSize = context.state.contentItemsQueryParams.pageSize;

    function getQuery() {
      let query = '';
      for (const param in context.state.contentItemsQueryParams) {
        if (!context.state.contentItemsQueryParams.hasOwnProperty(param)) continue;
        query += `&${param}=${context.state.contentItemsQueryParams[param]}`;
      }
      return query;
    }

    const contentItemsPayload = {
      feedId: context.state.feedId,
      filtersQuery: getQuery(),
    };

    return contentApi.getFeedContentItems(contentItemsPayload)
      .then((contentItems) => {
        context.commit(types.NEW_SET_CONTENT_ITEMS, contentItems.contentItems || []);
        context.commit(types.SET_CONTENT_TOTAL_ITEMS, contentItems.totalItems || 0);
        context.commit(types.SET_CONTENT_TOTAL_PUBLISHED_ITEMS, contentItems.totalPublished || 0);
        context.commit(types.SET_IS_SELF_SERVICE_CONTENT, contentItems.isSelfService || false);
        return Promise.resolve(contentItems);
      })
      .catch((errors) => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: `${errors}`,
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      });
  },
  [types.NEW_FETCH_DISPLAY_PROPERTIES]: (context, payload) => {
    const creativesIds = [];
    // TODO: Now if I have time or in the Future: Change this logic to get the display properties for a single creativeId.
    // ^ This is useful for reducing the amount of calls to make when accessing the page.
    context.state.creatives.forEach((creative) => {
      if (!creative.paused) creativesIds.push(creative.id);
    });
    const campaignId = context.rootState.campaigns.campaign.id;
    creativesIds.forEach((creativeId) => {
      contentApi.getAllCreativeDisplayProperties(campaignId, { creativeId })
        .then((displayProperties) => {
          context.commit(types.NEW_SET_CONTENT_ITEMS_DISPLAY_PROPERTIES, {
            creativeId,
            displayProperties,
          });
        })
        .catch((errors) => {
          context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
            message: `${errors}`,
            type: 'danger',
          }, { root: true });
        });
    });
    context.dispatch(types.FETCH_IMAGE_ASSET_NAMES);
    context.commit(types.SET_LOADING_ARTICLES_SECTION, false);
  },
  [types.FETCH_CONTENT_ITEM]: (context, payload) => contentApi.getContentItem(payload, payload.contentId)
    .then((response) => {
      context.commit(types.NEW_SET_CONTENT_ITEMS, [response]);
      return Promise.resolve(response);
    })
    .catch(() => {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Failed to get article',
        type: 'danger',
      }, { root: true });
      return Promise.reject();
    }),
  [types.FETCH_IMAGE_ASSET_NAMES]: async (context) => {
    if (!context.rootGetters[`campaigns/${campaignTypes.GET_HAS_CAMPAIGN_ACCESS}`]) return Promise.resolve([]);
    const folder = context.state.creativeTypeSelected === 'IMAGE' ? 'creative' : 'image';
    const payload = {
      bucket: 'CREATIVE_IMAGE',
      folder,
    };
    const imageAssetNames = await context.dispatch(`storage/${storageTypes.FETCH_CAMPAIGN_FILE_NAMES}`, payload, { root: true });
    context.commit(types.SET_IMAGE_ASSET_NAMES, imageAssetNames);
    return Promise.resolve(imageAssetNames);
  },
  [types.FETCH_IMAGE_ASSET]: async (context, payload) => {
    const folder = context.state.creativeTypeSelected === 'IMAGE' ? 'creative' : 'image';
    const campaignFilePayload = {
      bucket: 'CREATIVE_IMAGE',
      folder: `${folder}/${payload.creativeSizeName}`,
      fileName: payload.imageName,
    };
    return context.dispatch(`storage/${storageTypes.FETCH_CAMPAIGN_FILE}`, campaignFilePayload, { root: true });
  },
  [types.DELETE_IMAGE_ASSET]: async (context, payload) => {
    const folder = context.state.creativeTypeSelected === 'IMAGE' ? 'creative' : 'image';
    const campaignFilePayload = {
      bucket: 'CREATIVE_IMAGE',
      folder: `${folder}/${payload.creativeSizeName}`,
      fileName: payload.imageName,
    };
    context.dispatch(`storage/${storageTypes.DELETE_CAMPAIGN_FILE}`, campaignFilePayload, { root: true });
    context.commit(types.REMOVE_IMAGE_ASSET_NAME, payload);
    return Promise.resolve();
  },
  [types.SET_CONTENT_EDITOR_ARTICLE]: (context, payload) => {
    if (helper.objLength(payload) > 0) {
      for (const property in payload) {
        if (!payload.hasOwnProperty(property)) continue;
        context.commit(types.SET_CONTENT_EDITOR_ARTICLE, {
          property,
          value: payload[property],
        });
      }
    } else context.commit(types.SET_CONTENT_EDITOR_ARTICLE, {});
  },
  [types.SET_SELECTED_ARTICLE_UUID]: (context, payload) => {
    context.commit(types.SET_SELECTED_ARTICLE_UUID, payload);
    return Promise.resolve();
  },
  [types.SET_FILTERS_QUERY]: (context, payload) => {
    context.commit(types.SET_FILTERS_QUERY, payload);
  },
  [types.SET_CONTENT_ITEM_QUERY_PARAM]: (context, payload) => {
    context.commit(types.SET_CONTENT_ITEM_QUERY_PARAM, payload);
    return Promise.resolve();
  },
  [types.RESET_CONTENT_ITEMS_QUERY_PARAMS]: (context) => {
    context.dispatch(types.SET_CONTENT_ITEM_QUERY_PARAM, {});
    return Promise.resolve();
  },
  [types.SCRAPE_CONTENT]: (context, payload) => contentApi.sendContentForScraping(payload)
    .then((res) => {
      context.commit(types.SET_CONTENT_SCRAPE_ID, res.id);
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'URLs sent for processing',
        type: 'success',
      }, { root: true });
    })
    .catch((error) => error),
  [types.RESCRAPE_CONTENT]: (context, payload) => {
    const patchScrapePayload = {
      emailOnCompletion: payload.emailOnCompletion ? payload.emailOnCompletion : context.state.emailOnCompletion,
      ...payload,
    };
    return contentApi.patchScrapedContent(patchScrapePayload)
      .then(() => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'URLs sent for processing',
          type: 'success',
        }, { root: true });
      })
      .catch((error) => error);
  },
  [types.SCRAPE_FILE_CONTENT]: (context, payload) => contentApi.sendFileContentForScraping(payload)
    .then((res) => {
      context.commit(types.SET_CONTENT_SCRAPE_ID, res.id);
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'File content sent for processing',
        type: 'success',
      }, { root: true });
    })
    .catch((error) => error),
  [types.UPLOAD_URLS_SPREADSHEET_FOR_SCRAPE]: (context, payload) => contentApi.uploadURLsSpreadsheet(payload)
    .then((response) => {
      context.commit(types.SET_CONTENT_SCRAPE_ID, response.id);
    }),
  [types.DELETE_ARTICLES]: async (context, payload) => {
    let failedToDelete = 0;
    const failedArticlesIds = [];
    const successfulArticlesIds = [];
    const haveIds = payload.hasOwnProperty('ids');
    if (!haveIds) {
      if (context.state.contentItemsQueryParams.hasOwnProperty('states')) {
        if (context.state.contentItemsQueryParams.states === 'FAILED') {
          await context.dispatch(types.DELETE_CONTENT_SCRAPES, payload)
            .catch(() => {
              failedToDelete.push('Failed');
            });
        } else {
          await context.dispatch(types.DELETE_CONTENT_ITEMS, payload)
            .catch(() => {
              failedToDelete.push('Successful');
            });
        }
      } else {
        await context.dispatch(types.DELETE_CONTENT_SCRAPES, payload)
          .catch(() => {
            failedToDelete.push('Failed');
          });
        await context.dispatch(types.DELETE_CONTENT_ITEMS, payload)
          .catch(() => {
            failedToDelete.push('Successful');
          });
      }
    } else {
      payload.ids.forEach((id) => {
        if (context.getters.GET_FAILED_SCRAPED_CONTENT_ITEMS.find((article) => article.id === id)) {
          failedArticlesIds.push(id);
        } else {
          successfulArticlesIds.push(id);
        }
      });
      if (failedArticlesIds.length > 0) {
        await context.dispatch(types.DELETE_CONTENT_SCRAPES, {
          ...payload,
          ids: failedArticlesIds,
        })
          .catch(() => {
            failedToDelete++;
          });
      }
      if (successfulArticlesIds.length > 0) {
        await context.dispatch(types.DELETE_CONTENT_ITEMS, {
          ...payload,
          ids: successfulArticlesIds,
        })
          .catch(() => {
            failedToDelete++;
          });
      }
    }
    if (failedToDelete > 0) {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: `Failed to delete ${failedToDelete < 2 ? 'some article(s)' : 'article(s)'}`,
        type: 'danger',
      }, { root: true });
      return Promise.reject();
    }
    context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
      message: 'Article(s) deleted',
      type: 'success',
    }, { root: true });
    return Promise.resolve();
  },
  [types.DELETE_CONTENT_SCRAPES]: async (context, payload) => {
    const haveIds = payload.hasOwnProperty('ids');
    const requestPayload = {
      advertiserId: payload.advertiserId,
      feedId: payload.feedId,
      contentScrapeId: payload.contentScrapeId,
    };
    if (haveIds) {
      if (payload.ids.length > 0) requestPayload.ids = payload.ids;
      else return Promise.resolve();
    }
    if (context.getters.GET_FAILED_SCRAPED_CONTENT_ITEMS.length > 0) {
      return contentApi.deleteContentScrapes(requestPayload)
        .catch(() => Promise.reject());
    }
    return Promise.resolve();
  },
  [types.DELETE_CONTENT_ITEMS]: async (context, payload) => {
    const haveIds = payload.hasOwnProperty('ids');
    const requestPayload = {
      advertiserId: payload.advertiserId,
      feedId: payload.feedId,
      campaignId: payload.campaignId,
    };
    if (haveIds) {
      const filteredIds = payload.ids.filter((id) => context.getters.GET_ARTICLE_BY_ID(id).state === 'DRAFT');
      if (filteredIds.length > 0) requestPayload.ids = filteredIds;
      else return Promise.reject();
    } else {
      requestPayload.filters = buildFilters(context);
    }

    return contentApi.deleteContentItems(requestPayload)
      .catch(() => Promise.reject());
  },
  [types.SCRAPED_CONTENT]: (context, payload) => {
    const interval = 500;
    const checkCondition = (resolve, reject) => {
      contentApi
        .getScrapedContent(payload)
        .then((response) => {
          if (response.scrapes.length !== 0) {
            const { items } = response.scrapes[0];
            context.commit(types.SET_SCRAPED_CONTENT, items);
            context.commit(types.NEW_SET_SCRAPED_CONTENT, items);
            context.commit(types.SET_CONTENT_SCRAPE_ID, response.scrapes[0].id);
            const result = items.find((obj) => obj.status.startsWith('IN_PROGRESS'));
            if (typeof result === 'undefined') {
              resolve(response);
            } else {
              setTimeout(checkCondition, interval, resolve, reject);
            }
          } else {
            setTimeout(checkCondition, interval, resolve, reject);
          }
        })
        .catch((Error) => {
          reject(Error);
        });
    };
    return new Promise(checkCondition);
  },
  [types.FETCH_FEED_CONTENT_ITEMS]: (context, feedId) => contentApi
    .getFeedContent(feedId, context.state.page, context.state.pageSize, context.state.creative.id)
    .then((response) => {
      context.commit(types.SET_CONTENT_TOTAL_ITEMS, response.totalItems);
      context.commit(types.SET_CONTENT_ITEMS, response.contentItems);
      context.commit(types.SET_IS_SELF_SERVICE_CONTENT, response.isSelfService);
      context.commit(types.SET_CONTENT_TOTAL_PUBLISHED_ITEMS, response.totalPublished);
      return response;
    }),
  [types.FETCH_FILTERED_FEED_CONTENT_ITEMS]: (context, { feedId, allContent }) => {
    const { page, query, pageSize } = context.state;
    const creativeId = context.state.creative.id;

    const getFeedContentItemsPromise = allContent
      ? contentApi.getAllFeedContent(feedId, query, creativeId)
      : contentApi.getFilteredFeedContent(feedId, page, pageSize, query, creativeId);

    return getFeedContentItemsPromise
      .then((response) => {
        const promise = new Promise(async (resolve) => {
          context.commit(types.SET_CONTENT_TOTAL_ITEMS, response.totalItems);
          context.commit(types.SET_CONTENT_TOTAL_PUBLISHED_ITEMS, response.totalPublished);
          if (context.state.contentListType === 'SHOWCASE' || context.state.query !== '') {
            context.commit(types.SET_CONTENT_ITEMS, response.contentItems);
          } else {
            context.commit(types.RESET_CONTENT_ITEM);
            const itemList = response.contentItems;
            if (itemList.length === 0) return resolve([]);
            itemList.map(async (item) => context.commit(types.ADD_CONTENT_ITEM, item));
          }
          context.commit(types.SET_IS_SELF_SERVICE_CONTENT, response.isSelfService);
          resolve(response);
        });
        return promise;
      });
  },
  [types.FETCH_FEED_CONTENT_ITEMS_BY_ID]: (context, payload) => contentApi
    .getFeedContentById(payload.feedId,
      payload.contentItemId, context.state.pageSize, context.state.creative.id)
    .then((response) => {
      context.commit(types.SET_CURRENT_PAGE, response.page);
      context.commit(types.SET_CONTENT_TOTAL_ITEMS, response.totalItems);
      context.commit(types.SET_CONTENT_ITEMS, response.contentItems);
      context.commit(types.SET_IS_SELF_SERVICE_CONTENT, response.isSelfService);
      context.commit(types.SET_CONTENT_TOTAL_PUBLISHED_ITEMS, response.totalPublished);
      return response;
    }),
  [types.FETCH_CONTENT_COMMENTS_COUNT]: (context, payload) => contentApi
    .getContentCommentsCount(payload)
    .then((response) => {
      context.commit(types.SET_COMMENTS_COUNT, response.comments);
      return response.comments;
    }),
  [types.FETCH_CONTENT_ITEMS]: async (context, payload) => {
    context.commit(types.RESET_CONTENT_ITEM);
    const completedItems = context.state.scrapedContent.filter((obj) => (obj.status === 'COMPLETED' || obj.status === 'MANUALLY_ADDED'));
    const promises = await Promise.all(completedItems.map((item) => contentApi.getContentItem(payload, item.contentItemId)
      .then((content) => {
        content.imageUrl = (content.imageUrl !== null) ? content.imageUrl : '/images/image-not-set.png';
        return content;
      })));
    promises.map(async (item) => context.commit(types.ADD_CONTENT_ITEM, item));

    context.commit(types.SET_CONTENT_TOTAL_ITEMS, promises.length);
    return promises;
  },
  [types.FETCH_ALL_CONTENT_ITEMS_BY_FEED_ID]: (context) => contentApi.getAllContentItemsByFeedId(context.state.feedId)
    .then((response) => {
      context.commit(types.SET_FEED_CONTENT_ITEMS, response.contentItems);
      return response.contentItems;
    }),
  [types.FETCH_LIVE_CONTENT_ITEMS]: (context, payload) => contentApi.getContentItems(payload)
    .then((response) => Promise.resolve(response.contentItems))
    .catch(() => {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Failed to get content items',
        type: 'danger',
      }, { root: true });
      return Promise.reject();
    }),
  [types.FETCH_LANGUAGES]: (context, payload) => {
    if (context.state.languages.length !== 0) return Promise.resolve(context.state.languages);
    return contentApi.fetchLanguages()
      .then((response) => {
        context.commit(types.SET_LANGUAGES, response.languages.filter((language) => language.name !== 'Multilingual'));
        return Promise.resolve(response);
      })
      .catch(() => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Failed to get the available languages',
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      });
  },
  [types.PATCH_LANGUAGES]: (context, payload) => {
    if (payload.hasOwnProperty('contentItemIds')) {
      const filteredIds = payload.contentItemIds.filter((id) => ['DRAFT', 'PAUSED'].includes(context.getters.GET_ARTICLE_BY_ID(id).state));
      if (filteredIds.length === 0) {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'You cannot change the language for the selected article(s)',
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      }
      payload.contentItemIds = filteredIds;
    } else {
      payload.filters = buildFilters(context);
    }
    return contentApi.patchLanguages(payload)
      .catch(() => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Failed to update the article(s) languages',
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      });
  },
  [types.SET_CONTENT_ITEM_PUBLISHING_STATE]: (context, payload) => {
    const acceptedStates = [];
    if (payload.action === 'PUBLISH') {
      acceptedStates.splice(0, acceptedStates.length, ...['DRAFT', 'PAUSED']);
    } else if (payload.action === 'UNPUBLISH') {
      acceptedStates.splice(0, acceptedStates.length, ...['PUBLISHED', 'SCHEDULED']);
    }
    if (payload.hasOwnProperty('contentItemIds')) {
      const filteredIds = payload.contentItemIds.filter((id) => {
        const article = context.getters.GET_ARTICLE_BY_ID(id);
        return acceptedStates.includes(article.state)
          && article.hasOwnProperty('matchingHealth')
          && article.matchingHealth !== 'LOW';
      });
      if (filteredIds.length === 0) {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: `Selected article(s) cannot be ${
            payload.action === 'PUBLISH' ? 'published'
              : payload.action === 'UNPUBLISH' ? 'paused'
                : 'updated'
          }`,
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      }
      payload.contentItemIds = filteredIds;
    } else {
      payload.filters = buildFilters(context);
    }
    return contentApi.setContentItemState(payload)
      .then(() => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Article(s) state updated',
          type: 'success',
        }, { root: true });
        return Promise.resolve();
      })
      .catch(() => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Failed to update article(s) state',
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      });
  },
  [types.SET_CONTENT_ITEM_SCHEDULE]: (context, payload) => {
    if (payload.hasOwnProperty('contentItemIds')) {
      const filteredIds = payload.contentItemIds.filter((id) => {
        const article = context.getters.GET_ARTICLE_BY_ID(id);
        return article.hasOwnProperty('matchingHealth') && article.matchingHealth !== 'LOW';
      });
      if (filteredIds.length === 0) {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Selected article(s) cannot be scheduled',
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      }
      payload.contentItemIds = filteredIds;
    } else {
      payload.filters = buildFilters(context);
    }
    return contentApi.setContentItemSchedule(payload)
      .then(() => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Article(s) schedule added',
          type: 'success',
        }, { root: true });
        return Promise.resolve();
      })
      .catch(() => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Failed to add article schedule(s)',
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      });
  },
  [types.SAVE_CONTENT_EDITOR_CHANGES]: (context, payload) => {
    const contentApiMethod = payload.state === 'FAILED' ? 'patchScrapedContentItem' : 'updateContentItem';
    return contentApi[contentApiMethod](payload)
      .then((contentItem) => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Article saved successfully',
          type: 'success',
        }, { root: true });
        return Promise.resolve(contentItem);
      })
      .catch(() => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Failed to save article. Try again later.',
          type: 'danger',
        }, { root: true });
        return Promise.reject();
      });
  },
  [types.UPDATE_CONTENT_ITEM]: (context, payload) => contentApi
    .updateContentItem(payload)
    .then((contentItem) => {
      context.commit(types.UPDATE_ITEM, contentItem);
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Content item updated',
        type: 'success',
      }, { root: true });
      return contentItem;
    }),
  [types.DELETE_CONTENT_ITEM]: (context, payload, reject) => contentApi
    .deleteContentItem(payload)
    .then(() => {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Content item deleted',
        type: 'success',
      }, { root: true });
    })
    .catch(() => {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Content item cannot be deleted',
        type: 'danger',
      }, { root: true });
    }),
  [types.UPDATE_CONTENT_DISPLAY_COPY]: (context, payload) => {
    if (Object.keys(payload.body).includes('content')) {
      payload.body.content = payload.body.content.replace(/\r\n/g, '<br/>').replace(/[\r\n]/g, '<br/>');
    } else if (Object.keys(payload.body).includes('displayContent')) {
      payload.body.displayContent = payload.body.displayContent.replace(/\r\n/g, '<br/>').replace(/[\r\n]/g, '<br/>');
    }
    return contentApi
      .updateContentDisplayCopy(context.rootState.campaigns.campaign.id, payload)
      .then((contentItem) => {
        context.commit(types.UPDATE_CONTENT_ITEMS_DISPLAY_PROPERTIES, contentItem);
        context.commit(types.UPDATE_DISPLAY_COPY, { contentItemUuid: contentItem?.encodedExternalId, displayCopy: contentItem.displayProperties });
        context.dispatch(types.FETCH_IMAGE_ASSET_NAMES);
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Content item updated',
          type: 'success',
        }, { root: true });
        if (Object.keys(payload.body).includes('imageFileName') || Object.keys(payload.body).includes('creativeImage')) {
          context.dispatch(types.TRIGGER_CREATIVE_RERENDER);
        }
        return contentItem;
      });
  },
  [types.PATCH_CONTENT_ITEM]: (context, payload) => {
    const contentPayload = {
      advertisersId: context.rootState.campaigns.selectedAdvertiser.id,
      feedId: context.state.feedId,
      contentScrapeId: context.state.scrapingBatchId,
      contentScrapeItemId: payload.scrapeItemId,
      body: {
        url: payload.url,
        title: payload.title,
        fullText: payload.articleContent,
        contentBody: payload.articleContent,
        cta: payload.cta || null,
      },
    };
    return contentApi.patchScrapedContentItem(contentPayload);
  },
  [types.POST_CREATIVES]: (context, payload) => contentApi.postCreatives(context.rootState.campaigns.campaign.id, {
    advertiserId: context.rootState.campaigns.campaign.advertiserId,
    feedId: context.rootState.campaigns.campaign.feedId,
    orderId: context.rootState.campaigns.order.id,
    ...payload,
  }).then((creativesResponse) => handleCreatives(creativesResponse, context)),
  [types.POST_CREATIVES_WITH_TYPE]: (context) => {
    const payload = {
      creativeType: context.state.creativeTypeSelected,
      sizes: context.state.adUnitsSelected,
    };
    return contentApi.postCreativesWithType(context.rootState.campaigns.campaign.id, payload)
      .then((creativesResponse) => handleCreatives(creativesResponse, context));
  },
  [types.PUT_CREATIVES]: (context, payload) => contentApi.putCreatives(context.rootState.campaigns.campaign.id, {
    advertiserId: context.rootState.campaigns.campaign.advertiserId,
    feedId: context.rootState.campaigns.campaign.feedId,
    orderId: context.rootState.campaigns.order.id,
    ...payload,
  }).then((creativesResponse) => handleCreatives(creativesResponse, context)),
  [types.PUT_CREATIVES_WITH_TYPE]: (context) => {
    let creativeSizes = context.state.adUnitsSelected;
    if (creativeSizes.length === 0) {
      creativeSizes = ['MEDIUM_RECTANGLE', 'HALF_PAGE', 'BILLBOARD'];
      context.commit(types.SET_ADD_UNITS_SELECTED, creativeSizes);
    }
    context.commit(types.CLEAR_CREATIVES);
    const payload = {
      creativeType: context.state.creativeTypeSelected,
      sizes: context.state.adUnitsSelected,
    };
    return contentApi.putCreativesWithType(context.rootState.campaigns.campaign.id, payload)
      .then((creativesResponse) => handleCreatives(creativesResponse, context));
  },
  [types.UPDATE_CURRENT_SELECTED_CREATIVE_ID]: ({ state, commit }, nextCreative) => {
    const { activeCreatives } = state;
    let newIndex;
    const currentlySelectedIndex = activeCreatives
      .findIndex((creative) => creative.id === state.selectedCreativeId);
    if (nextCreative) {
      newIndex = currentlySelectedIndex + 1;
    } else {
      newIndex = currentlySelectedIndex - 1;
    }
    commit(types.SET_CREATIVE, activeCreatives[newIndex]);
  },
  [types.SET_SELECTED_CREATIVE_ID]: (context, creativeId) => {
    const selectedCreative = context.state.creatives.find((creative) => creative.id === creativeId);
    if (selectedCreative) context.commit(types.SET_CREATIVE, selectedCreative);
    context.commit(types.SET_CREATIVE, selectedCreative);
  },
  [types.PATCH_CREATIVE_PROPERTIES]: (context, payload) => contentApi.patchCreative(context.rootState.campaigns.campaign.id, payload)
    .then((response) => {
      context.commit(types.UPDATE_CREATIVES_PROPERTIES_BY_ID, response.creatives);
      return Promise.resolve();
    }),
  [types.PATCH_CREATIVE]: (context, payload) => {
    const creativesPayload = {
      advertisersId: context.rootState.campaigns.selectedAdvertiser.id,
      orderId: payload.orderId,
      creativeId: payload.id,
      body: {
        name: payload.name,
        creativeTemplateId: payload.creativeTemplateId,
        platforms: payload.platforms,
      },
      properties: {},
    };
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('backgroundColour')) {
      creativesPayload.properties = {
        backgroundColour: payload.backgroundColour,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('headlineFontFamily')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        headlineFontFamily: payload.headlineFontFamily,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('headlineFontSize')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        headlineFontSize: payload.headlineFontSize,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('headlineFontColour')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        headlineFontColour: payload.headlineFontColour,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('bodyFontFamily')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        bodyFontFamily: payload.bodyFontFamily,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('bodyFontSize')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        bodyFontSize: payload.bodyFontSize,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('bodyClamp')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        bodyClamp: payload.bodyClamp,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('bodyFontColour')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        bodyFontColour: payload.bodyFontColour,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('ctaBackgroundColour')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        ctaBackgroundColour: payload.ctaBackgroundColour,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('ctaFontFamily')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        ctaFontFamily: payload.ctaFontFamily,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('ctaFontSize')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        ctaFontSize: payload.ctaFontSize,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('ctaFontColour')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        ctaFontColour: payload.ctaFontColour,
      };
    }
    if (context.rootGetters[`templates/${templatesTypes.GET_TEMPLATE_EDITABLE_PROPERTIES}`].includes('clientName')) {
      creativesPayload.properties = {
        ...creativesPayload.properties,
        clientName: payload.clientName,
      };
    }
    return contentApi.patchCreative(context.rootState.campaigns.campaign.id, creativesPayload)
      .then((creative) => {
        context.commit(types.SET_CREATIVE, creative.creatives[0]);
        context.commit(types.UPDATE_CREATIVES_PROPERTIES_BY_ID, creative.creatives);
        if (payload.showMessage) {
          context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
            message: 'Creative properties set',
            type: 'success',
          }, { root: true });
        }
        return creative;
      });
  },
  [types.FETCH_CREATIVE_TEMPLATES]: (context, payload) => contentApi.fetchCreativeTemplates(payload)
    .then((response) => {
      context.commit(types.SET_CREATIVE_TEMPLATES, response);
      return Promise.resolve(response);
    })
    .catch((Error) => Promise.reject(Error)),
  [types.FETCH_CREATIVE_TEMPLATES_BY_CAMPAIGNIDS]: (context, payload) => {
    const checkCondition = (resolve, reject) => contentApi
      .getCreativeTemplateByCampaignIds(payload)
      .then((response) => {
        context.commit(types.SET_CREATIVE_TEMPLATES, response);
        resolve(response);
      })
      .catch((Error) => {
        reject(Error);
      });
    return new Promise(checkCondition);
  },
  [types.FETCH_CREATIVE_TEMPLATE_BY_ID]: (context, payload) => contentApi
    .getCreativeTemplateById(payload)
    .then((creative) => {
      context.commit(`templates/${templatesTypes.SET_CREATIVES_TEMPLATES_EDITABLE_PROPERTIES}`, creative, { root: true });
      return creative;
    }),
  [types.TRIGGER_CREATIVE_RERENDER]: (context, payload) => {
    const timeStamp = new Date().getTime();
    context.commit(types.TRIGGER_CREATIVE_RERENDER, timeStamp);
  },
  [types.GET_TEMPLATE_BY_ID]: (context, payload) => contentApi
    .getCreativeTemplateById(payload)
    .then((response) => (response)),
  [types.UPLOAD_CREATIVE_DISPLAY_IMAGE]: (context, payload) => {
    payload.body = {};
    payload.body.imageType = context.state.creativeTypeSelected === 'IMAGE' ? 'CREATIVE' : 'IMAGE';
    contentApi.uploadCreativeDisplayImage(context.rootState.campaigns.campaign.id, payload)
      .then((contentItem) => {
        const { encodedExternalId, displayProperties } = contentItem;
        context.commit(types.UPDATE_DISPLAY_COPY, {
          contentItemUuid: encodedExternalId,
          displayCopy: displayProperties,
        });
        context.commit(types.UPDATE_CONTENT_ITEMS_DISPLAY_PROPERTIES, {
          contentItemUuid: contentItem.contentUuid,
          active: context.getters.GET_CONTENT_ITEM_ACTIVE_STATE(contentItem.contentUuid, payload.creativeId),
          displayProperties: contentItem.displayProperties,
        });
        context.dispatch(types.FETCH_IMAGE_ASSET_NAMES);
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Content image set',
          type: 'success',
        }, { root: true });
        context.dispatch(types.TRIGGER_CREATIVE_RERENDER);
        return contentItem;
      });
  },
  [types.SWAP_CREATIVE_DISPLAY_IMAGE]: (context, payload) => contentApi
    .swapCreativeDisplayImage(context.rootState.campaigns.campaign.id, payload)
    .then((displayPropertiesResponse) => {
      const { encodedExternalId, displayProperties, contentUuid } = displayPropertiesResponse;
      context.commit(types.UPDATE_DISPLAY_COPY, { contentItemUuid: encodedExternalId, displayCopy: displayProperties });
      context.commit(types.UPDATE_CONTENT_ITEMS_DISPLAY_PROPERTIES, {
        contentItemUuid: contentUuid,
        active: context.getters.GET_CONTENT_ITEM_ACTIVE_STATE(contentUuid, payload.creativeId),
        displayProperties: displayPropertiesResponse.displayProperties,
      });
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Content image updated',
        type: 'success',
      }, { root: true });
      return displayPropertiesResponse;
    }),
  [types.DELETE_CREATIVE_DISPLAY_IMAGE]: (context, payload) => contentApi
    .deleteCreativeDisplayImage(context.rootState.campaigns.campaign.id, payload)
    .then(() => {
      const tempPayload = {
        contentItemUuid: payload.contentItemUuid,
        active: context.getters.GET_CONTENT_ITEM_ACTIVE_STATE(payload.contentItemUuid, payload.creativeId),
        displayProperties: context.getters.GET_CONTENT_ITEM_DISPLAY_PROPERTIES(payload.contentItemUuid, payload.creativeId),
      };
      const { creativeTypeSelected } = context.state;
      if (creativeTypeSelected === 'IMAGE') delete tempPayload.displayProperties.creativeImage;
      else delete tempPayload.displayProperties.imageFileName;
      context.commit(types.UPDATE_CONTENT_ITEMS_DISPLAY_PROPERTIES, tempPayload);
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Content image deleted',
        type: 'success',
      }, { root: true });
    }),
  [types.FETCH_EXISTING_CONTENT_SCRAPES]: (context, payload) => contentApi
    .getFeed(payload.advertiserId, payload.feedId)
    .then(() => {
      const advertisersId = context.rootState.campaigns.selectedAdvertiser.id;
      return contentApi
        .getScrapedContent({ advertisersId, feedId: payload.feedId })
        .then((contentScrapes) => {
          if (contentScrapes.scrapes.length !== 0) {
            context.commit(types.SET_CONTENT_SCRAPE_ID, contentScrapes.scrapes[0].id);
            context.commit(types.SET_SCRAPED_CONTENT, contentScrapes.scrapes[0].items);
          }
          return contentScrapes;
        });
    }),
  [types.FETCH_EXISTING_CREATIVES]: (context, payload) => contentApi
    .getCreatives(context.rootState.campaigns.campaign.id ?? payload?.campaignId)
    .then((creativesResponse) => handleCreatives(creativesResponse, context, context.state.selectedCreativeId)),
  [types.FETCH_CREATIVE_CONTENT_STATES]: (context, { advertiserId, creativeId }) => contentApi
    .getCreativeContentStates({ advertiserId, creativeId })
    .then((contentStates) => {
      context.commit(types.SET_CREATIVE_CONTENT_STATES, contentStates);
    }),
  [types.UPDATE_A_CREATIVE_CONTENT_STATE]: (context, payload) => {
    const { creativeId, updatedItem } = payload;
    return contentApi
      .patchCreativeContentStates({ campaignId: context.rootState.campaigns.campaign.id, creativeId, updatedItem })
      .then(() => {
        context.commit(types.UPDATE_A_CREATIVE_CONTENT_STATE, payload);
        return Promise.resolve();
      });
  },
  [types.FETCH_EXISTING_CREATIVES_AS_SHAREE]: (context, campaignIds) => contentApi
    .getCreativesAsSharee(campaignIds)
    .then((creativesResponse) => handleCreatives(creativesResponse, context, undefined, true)),
  [types.PATCH_LOGO_IMAGE]: (context, payload) => {
    if (payload.logoURL) {
      const logoImagePayload = {
        advertisersId: context.rootState.campaigns.selectedAdvertiser.id,
        creativeId: payload.creativeId,
        creativeTemplateId: context.rootGetters[`templates/${templatesTypes.GET_SELECTED_CREATIVE_TEMPLATE_ID}`],
        properties: {
          logo: payload.logoURL,
        },
      };
      if (payload.type === 'unit') {
        return contentApi.patchCreative(context.rootState.campaigns.campaign.id, logoImagePayload)
          .then((creative) => {
            context.commit(types.SET_CREATIVE, creative.creatives[0]);
            context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
              message: 'Unit logo uploaded successfully',
              type: 'success',
            }, { root: true });
            return creative;
          });
      }
      const campaignLogoImagePayload = {
        advertiserId: payload.advertisersId,
        campaignId: payload.campaignId,
        properties: {
          logo: payload.logoURL,
        },
      };
      return context.dispatch(`campaigns/${campaignTypes.PATCH_CAMPAIGN_PROPERTIES}`, campaignLogoImagePayload, { root: true });
    }
    const logoImagePayload = {
      advertisersId: payload.advertisersId,
      campaignId: payload.campaignId,
      creativeId: payload.creativeId,
      formData: payload.logoImage.formData,
    };
    if (payload.type === 'unit') {
      return contentApi.uploadLogoImage(context.rootState.campaigns.campaign.id, logoImagePayload)
        .then((creative) => {
          context.commit(types.SET_CREATIVE, creative.creatives[0]);
          context.commit(types.UPDATE_CREATIVES_PROPERTIES_BY_ID, creative.creatives);
          context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
            message: 'Unit logo uploaded successfully',
            type: 'success',
          }, { root: true });
          return creative;
        });
    }
    return context.dispatch(`campaigns/${campaignTypes.UPLOAD_LOGO_IMAGE}`, logoImagePayload, { root: true });
  },
  [types.DELETE_LOGO_IMAGE]: (context, payload) => {
    if (payload.type === 'unit') {
      return contentApi.deleteLogoImage(context.rootState.campaigns.campaign.id, payload).then(() => {
        const index = context.state.creatives.findIndex((creative) => creative.id === payload.creativeId);
        Vue.delete(context.state.creatives[index].properties, 'logo');
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Unit Logo deleted',
          type: 'success',
        }, { root: true });
      });
    }
    return context.dispatch(`campaigns/${campaignTypes.DELETE_CAMPAIGN_LOGO}`, payload, { root: true });
  },
  [types.RESET_CREATIVE_PROPERTIES]: (context, payload) => contentApi.deleteCreativeProperties(context.rootState.campaigns.campaign.id, payload).then(() => {
    context.dispatch(types.FETCH_EXISTING_CREATIVES, { advertiserId: payload.advertiserId });
    context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
      message: 'Creative properties refreshed',
      type: 'success',
    }, { root: true });
  }),
  [types.FETCH_CONTENT_COMMENTS]: (context, payload) => contentApi
    .getContentComments(payload)
    .then((response) => {
      context.commit(types.UPDATE_CURRENT_COMMENTS, response.comments);
      return response.comments;
    }),
  [types.POST_CONTENT_COMMENT]: (context, payload) => {
    if (context.state.isAddingNewAnnotation) {
      payload.body = {
        commentLocation: context.state.currentAnnotation,
        ...payload.body,
      };
    }
    return contentApi
      .postContentComment(payload).then((response) => {
        context.commit(types.INCREMENT_COMMENTS_COUNT,
          { contentUuid: payload.body.contentId });
        return response.comments;
      });
  },
  [types.SET_CURRENT_ANNOTATION]: (context, payload) => {
    context.commit(types.UPDATE_CURRENT_ANNOTATION, payload);
    context.commit(types.UPDATE_CURRENT_ANNOTATION_STATE, true);
  },
  [types.REMOVE_CURRENT_ANNOTATION]: (context) => {
    context.commit(types.UPDATE_CURRENT_ANNOTATION, {});
    context.commit(types.UPDATE_CURRENT_ANNOTATION_STATE, null);
    context.commit(types.TRIGGER_ANNOTATION, { commentLocation: null });
  },
  [types.TRIGGER_ANNOTATION]: (context, payload) => {
    context.commit(types.TRIGGER_ANNOTATION, payload.commentLocation);
    return Promise.resolve();
  },
  [types.SET_IS_SIDEBAR_INPUT_FOCUSED]: (context, payload) => {
    context.commit(types.SET_IS_SIDEBAR_INPUT_FOCUSED, payload);
    return Promise.resolve();
  },
  [types.TOGGLE_ARTICLE_SHARED_STATE]: (context, payload) => {
    if (payload.isChecked) {
      return contentApi
        .postSharedContentItem(payload.contentItem)
        .then((response) => {
          context.dispatch(types.FETCH_SHARED_CONTENT_ITEMS);
          return Promise.resolve(response);
        });
    }
    return contentApi.deleteSharedContentItem(payload.contentItem)
      .then((response) => {
        context.dispatch(types.FETCH_SHARED_CONTENT_ITEMS);
        return Promise.resolve(response);
      });
  },
  [types.TOGGLE_ALL_CONTENT_SHARED]: (context, payload) => {
    const { allShared } = payload;
    const contentItem = {
      campaignId: context.rootState.campaigns.campaign.id,
    };
    if (allShared) {
      return contentApi
        .postSharedContent(contentItem).then((response) => {
          context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
            message: 'All content items are now shared',
            type: 'success',
          }, { root: true });
          return response;
        });
    }
    return contentApi
      .deleteSharedContent(contentItem).then((response) => {
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'All content items were removed from being shared',
          type: 'success',
        }, { root: true });
        return response;
      });
  },
  [types.FETCH_SHARED_COUNT]: (context) => contentApi
    .getSharedCount(context.rootState.campaigns.campaign.id)
    .then((response) => {
      context.commit(types.SET_SHARED_COUNT, response.sharedCount);
      return response;
    }),
  [types.FETCH_SHARED_CONTENT_ITEMS]: (context) => contentApi
    .getSharedContentItems(context.rootState.campaigns.campaign.id)
    .then(async (response) => {
      await context.dispatch(types.FETCH_ALL_CONTENT_ITEMS_BY_FEED_ID);
      context.commit(types.SET_SHARED_CONTENT_ITEMS, response.sharedContentItemUuids);
      return response;
    }),
  [types.SELECT_ONLY_DRAFT]: (context) => contentApi
    .postSharedContentOnlyState({ campaignId: context.rootState.campaigns.campaign.id, states: 'DRAFT' })
    .then((response) => {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'All draft content items have been shared',
        type: 'success',
      }, { root: true });
      return response;
    }),
  [types.FETCH_CONTENT_DISPLAY_COPY]: async ({ state, commit }, withUuids = true) => {
    const contentItemsDisplayProperties = {};
    const uuids = withUuids ? state.newContentItems.map((item) => item.encodedExternalId) : null;
    const creativeIds = state.creatives.filter((creative) => !creative.paused).map((creative) => creative.id);
    if ((withUuids && uuids.length === 0) || creativeIds.length === 0) return;

    for (const creativeId of creativeIds) {
      // eslint-disable-next-line no-await-in-loop
      const allDisplayProperties = await contentApi.getAllCreativeDisplayProperties(state.campaign.id, {
        creativeId,
        uuids,
      });
      allDisplayProperties.forEach((contentDisplayProperty) => {
        const { contentItemUuid, displayProperties } = contentDisplayProperty;
        if (contentItemUuid && displayProperties) {
          contentItemsDisplayProperties[contentItemUuid] = contentItemsDisplayProperties[contentItemUuid]
            ? { ...contentItemsDisplayProperties[contentItemUuid], [creativeId]: displayProperties }
            : { [creativeId]: displayProperties };
        }
      });
    }
    commit(types.SET_ALL_DISPLAY_COPY, contentItemsDisplayProperties);
  },
  [types.FETCH_CUSTOM_PROPERTY_TYPES]: (context) => contentApi
    .getCustomProperties()
    .then((response) => {
      context.commit(types.SET_CUSTOM_PROPERTY_TYPES, response);
      return response;
    }),
  [types.SAVE_CUSTOM_PROPERTIES]: (context, payload) => {
    const defaultDisplayProperties = payload.customPropertyTypes.reduce((a, v) => ({ ...a, [v]: null }), {});
    const newDisplayProperties = payload.rows.reduce((a, v) => ({ ...a, [v.type]: v.value }), {});
    const displayProperties = { ...defaultDisplayProperties, ...newDisplayProperties };

    contentApi.updateContentDisplayCopy(context.rootState.campaigns.campaign.id, {
      body: displayProperties,
      id: payload.encodedExternalId,
      advertisersId: context.rootState.campaigns.selectedAdvertiser.id,
      creativeId: context.state.selectedCreativeId,
    })
      .then((contentItem) => {
        const { encodedExternalId } = contentItem;
        context.commit(types.UPDATE_DISPLAY_COPY, { contentItemUuid: encodedExternalId, displayCopy: contentItem?.displayProperties });
        context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
          message: 'Custom properties updated',
          type: 'success',
        }, { root: true });
        return contentItem;
      });
  },
  [types.SET_EMAIL_USER_ON_SCRAPE_COMPLETION]: (context, payload) => {
    context.commit(types.SET_EMAIL_USER_ON_SCRAPE_COMPLETION, payload);
  },
  [types.SET_CONTENT_ITEMS_URLS_CHANGED]: (context, payload) => {
    context.commit(types.SET_CONTENT_ITEMS_URLS_CHANGED, payload);
  },
  [types.FETCH_CONTENT_STATES]: (context) => {
    const { states } = context.state;
    if (states && states.length > 0) return states;
    return contentApi.getStates()
      .then((response) => {
        const contentStates = response.data.states.filter((state) => state !== 'APPROVAL');
        context.commit(types.SET_CONTENT_STATES, contentStates);
        return contentStates;
      });
  },
};

export default actions;
